import { validationObject } from 'utils/validations';
import { BusinessClientInfo } from 'utils/constants/informationText';
import { getFormInitialValues, optionalFormField } from 'utils/methods/helpers';
import { businessClientValidation } from 'utils/validationSchema/index.js';
import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import { USER_FIELDS } from 'utils/formFields/user';
import { LIST_WIDTH } from 'utils/constants/listview';
import ClientForm from 'containers/Pages/People/Customers/Layouts/CustomerForm';
import API from 'services/api';
import { transform } from 'utils/DataTransform/BusinessClients/BusinessClientDetailsDataTransform';
import { transformRawClient } from 'utils/DataTransform/Clients/ClientList';
import { ROLES } from 'utils/constants/roles';

export const validationSchema = () => {
  const validation = businessClientValidation;
  return validationObject(validation);
};

export const initialState = {
  archived: false,
  businessClientId: undefined,
  companyName: undefined,
  description: undefined,
  contact: undefined,
  newContact: false,
  country: '',
  email: undefined,
  emailVerified: false,
  phoneVerified: false,
  firstName: '',
  lastName: '',
  phone: undefined,
  employeeId: undefined,
  notes: '',
  languages: ['EN'],
};

export const initialValuesForSubPanel = {
  firstName: '',
  lastName: '',
  phone: undefined,
  employeeId: undefined,
  notes: '',
  languages: ['EN'],
  country: '',
  email: undefined,
};

export const initialValues = data => {
  const initial = getFormInitialValues(data);

  return initial;
};

export const filters = userAssignedDepartments => [
  {
    label: 'Archived',
    field: 'archived',
    type: 'toggle',
  },
  ...departmentFilter(userAssignedDepartments),
];

export const listViewColumns = [
  {
    headerName: 'Company ID',
    field: 'businessClientId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Company Name',
    field: 'name',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Contact Person',
    field: 'contactName',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'Phone',
    field: 'contactPhone',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  { headerName: 'Email', field: 'email', width: LIST_WIDTH.xl },
  {
    headerName: 'Departments',
    field: 'departments',
    width: LIST_WIDTH.xl,
  },
];

export const generalSection = userAssignedDepartments => [
  {
    field: 'businessClientId',
    label: 'Business Client ID',
    type: 'text',
    placeholder: 'Enter unique id',
    info: BusinessClientInfo.id,
    size: 'half',
  },
  {
    field: 'companyName',
    type: 'text',
    required: true,
    placeholder: 'Enter company name.',
    size: 'half',
  },
  ...optionalFormField({
    showWhen: userAssignedDepartments.length > 0,
    field: USER_FIELDS.departments({ userAssignedDepartments }),
  }),
];

export const detailedSection = ({
  updatedValues,
  companyName,
  businessClientPayload,
  embeddedBizClient,
  enableApiCall,
  embeddedBizID,
  embeddedselectedBusinessClient,
}) => [
  {
    field: 'address',
    type: 'address',
    placeholder: 'Enter Street Address',
    info: BusinessClientInfo.address,
    size: 'half',
  },
  {
    field: 'contact',
    label: 'Contact',
    // info: SiteInfo.contact,
    type: 'async-select',
    disabled: !embeddedBizID, // cannot make an api call unless there the business client is created
    size: 'half',
    fetchOptions: API.fetchUserList,
    fetchFilters: {
      securityCompanyId: businessClientPayload.securityCompanyId,
      roles: [ROLES.CLIENT.id],
      archived: false,
      businessClientId: embeddedBizID,
    },
    optionLabelKey: 'label',
    dataTransform: ({ data }) => {
      const transformedClient = transformRawClient(data);
      return transformedClient;
    },
    resetWhen: [
      {
        value: updatedValues,
        condition: val => {
          return val?.contact !== null;
        },
      },
    ],
  },
  {
    field: 'contact',
    disabled: !companyName || companyName.length === 0,
    type: 'embedded-form-follow-up',
    label: 'New Contact',
    component: ClientForm,
    archiveDelete: true,
    updatedValues,
    enableApiCall, // this will stop creating new business client if new contact is clicked everytime
    fetchApi: API.addBusinessClient,
    fetchPayload: businessClientPayload,
    dataFieldKey: 'embeddedselectedBusinessClient', // this key will have same name as prop passed in ClientForm as api values will be stored in it
    data: bizClient => {
      const transformBizClient = transform(bizClient);
      // store it in the state
      embeddedBizClient(transformBizClient);
    },
    hideTable: true,
    componentProps: {
      embeddedForm: true,
      disablePresist: true,
      embeddedselectedBusinessClient,
    },
  },
  {
    field: 'description',
    type: 'textArea',
    maxLength: 250,
    placeholder: 'Enter description',
  },
];
